import React, { useState } from "react";
import { Link } from "react-router-dom";

import './Nav.scss';

function Navbar() {
  const [burgerShowing, setBurgerShowing] = useState(false);

  function onClick(event) {
    setBurgerShowing(!burgerShowing);
  }

  function hideBurger() {
    setBurgerShowing(false);
  }

  return (
    <nav className="navbar has-shadow has-text-weight-bold" role="navigation" aria-label="main navigation">
      <div className="navbar-brand">
        <Link to="/" className="navbar-item honey-navbar-brand-item">
          <span className="honey-text-font-family honey-navbar-brand-logo">HoneyShare</span>
        </Link>
        <a
          href="#"
          className="navbar-burger honey-navbar-burger"
          role="button"
          aria-label="menu"
          aria-expanded="false"
          onClick={onClick}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div className={burgerShowing ? "navbar-menu is-active" : "navbar-menu"}>
        <div className="navbar-start">
          <Link to="/beecommandcenter" className="navbar-item honey-navbar-item" onClick={hideBurger}>
            BeeCommandcenter
          </Link>
          <Link to="/api" className="navbar-item honey-navbar-item" onClick={hideBurger}>
            API
          </Link>
          <Link to="/licenses" className="navbar-item honey-navbar-item" onClick={hideBurger}>
            Licenses
          </Link>
          <Link to="/experiments" className="navbar-item honey-navbar-item" onClick={hideBurger}>
            Experiments
          </Link>
          <Link to="/about" className="navbar-item honey-navbar-item" onClick={hideBurger}>
            About
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
